import { Mascot } from "@/components/brand/Mascot";
import { Barcode, Crown, Globe } from "@/components/brand/Doodles";
import { Brush } from "@/components/brand/Lettering";

const SHAPE = "polygon(24% 0, 76% 0, 100% 9%, 100% 100%, 0 100%, 0 9%)";

const Tag = ({ dark, className = "", style, children }) => (
  <div className={`relative ${className}`} style={style}>
    <svg viewBox="0 0 60 70" className="absolute -top-[62px] left-1/2 h-[70px] w-[60px] -translate-x-[40%] text-ink" fill="none" aria-hidden="true">
      <path d="M24 68C14 46 46 30 38 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
    <div className="h-full bg-ink p-[1.5px]" style={{ clipPath: SHAPE }}>
      <div className={`relative flex h-full flex-col items-center px-4 pb-5 pt-11 text-center ${dark ? "bg-ink text-cloud" : "bg-[#FBFAF4] text-ink"}`} style={{ clipPath: SHAPE }}>
        <span className="absolute left-1/2 top-3.5 h-3.5 w-3.5 -translate-x-1/2 rounded-full bg-cloud ring-[1.5px] ring-ink" />
        {children}
      </div>
    </div>
  </div>
);

export const HangTags = ({ className = "" }) => (
  <div className={`flex items-start justify-center gap-5 pt-16 ${className}`} data-testid="hang-tags" aria-label="the suspects hang tags">
    <Tag dark className="h-[300px] w-[176px]" style={{ transform: "rotate(-4deg)" }}>
      <Mascot size={62} label="" />
      <span className="mt-4 whitespace-nowrap font-display text-[29px] lowercase leading-none">the suspects</span>
      <span className="mt-1.5 font-a text-[7px] tracking-[0.2em] text-cloud/40">CERTIFIED SUS</span>
      <span className="my-4 h-px w-full bg-cloud/20" />
      <span className="font-mono text-[9px] uppercase leading-relaxed tracking-[0.25em]">Good people.<br />Sus ideas.</span>
      <Barcode size={70} className="mt-auto text-cloud" />
    </Tag>
    <Tag className="mt-10 h-[270px] w-[160px]" style={{ transform: "rotate(5deg)" }}>
      <Crown size={40} />
      <Brush lines={["Same same?", "Suspect."]} rotate={-7} halo={false} className="mt-5 text-[28px]" />
      <div className="mt-auto flex items-center gap-2">
        <Globe size={22} />
        <span className="font-mono text-[8px] uppercase tracking-[0.25em]">Toronto, CA</span>
      </div>
    </Tag>
  </div>
);
